// Copyright (c) 2019 Deere & Company

import {
    updateOktaAccessToken,
    updateOktaIsAuthenticated,
    updateOktaUserFirstName
} from './okta-state';

export default {
    updateOktaAccessToken,
    updateOktaIsAuthenticated,
    updateOktaUserFirstName
};
